import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { Color } from "app/pages/activation/components/RankWidget/types";

import * as SC from "./styles";

type DropdownButtonSchema = {
    children: ReactNode;
    isDisabled?: boolean;
    dataAutomation?: string;
    color?: Color;
};

export const DropdownButton = ({ children, isDisabled, dataAutomation, color }: DropdownButtonSchema) => (
    <SC.Container
        isDisabled={isDisabled}
        data-automation={dataAutomation}
        data-disabled={isDisabled}
        color={color}
    >
        {children}

        <SWReactIcons
            iconName="arrow"
            size="10px"
            iconColor={color ?? colorsPalettes.blue[400]}
        />
    </SC.Container>
);
